import React from "react";
import {
  BooleanPill,
  RecipientActionsCell,
  RecipientContactCell,
  RecipientIdentityCell,
  RecipientIdsCell,
  RecipientLocationCell,
  RecipientOrientationCell,
  RightsAndDutiesPill,
  getOriginLabel,
} from "./RecipientCells";

// Colonnes de la liste des allocataires (spec consommée par DataTable).
export function getRecipientColumns({ constants = {}, orgs = [] } = {}) {
  return [
    {
      key: "recipient",
      header: "Allocataire",
      className: "col-recipient",
      render: (r) => <RecipientIdentityCell recipient={r} />,
    },
    {
      key: "ids",
      header: "NIR / Matricule",
      className: "col-ids",
      render: (r) => <RecipientIdsCell recipient={r} />,
    },
    {
      key: "contact",
      header: "Contact",
      className: "col-contact",
      render: (r) => <RecipientContactCell recipient={r} />,
    },
    {
      key: "isActivated",
      header: "Compte activé",
      render: (r) => <BooleanPill value={!!r.isActivated} />,
    },
    {
      // « Possède un RDO » : l'API expose rdspAvailable = RDO encore à remplir.
      key: "rdo",
      header: "RDO",
      render: (r) => <BooleanPill value={!r.rdspAvailable} />,
    },
    {
      key: "location",
      header: "Lieu",
      className: "col-location",
      render: (r) => <RecipientLocationCell location={r.location} />,
    },
    {
      key: "rightsAndDuties",
      header: "SDD / NSDD",
      render: (r) => <RightsAndDutiesPill rightsAndDuties={r.rightsAndDuties} />,
    },
    {
      key: "origin",
      header: "Origine",
      className: "col-origin",
      render: (r) => getOriginLabel(r.origin, constants),
    },
    {
      key: "orientation",
      header: "Orientation",
      className: "col-orientation",
      render: (r) => <RecipientOrientationCell orientation={r.orientation} orgs={orgs} />,
    },
    {
      key: "actions",
      header: "Actions",
      headerSrOnly: true,
      className: "col-actions",
      render: (r) => <RecipientActionsCell recipient={r} />,
    },
  ];
}
